import PRODUCT_TYPE, { OPEN } from "../const/products";
var getSetpayLoanProcessingStatus = function (installment, productType, conditions) {
    if (!(conditions === null || conditions === void 0 ? void 0 : conditions.includes(OPEN)))
        return false;
    if (productType !== PRODUCT_TYPE.INSTALLMENT_LOAN)
        return false;
    var _a = installment || {}, loanTerm = _a.loanTerm, interestRate = _a.interestRate, startDate = _a.startDate, endDate = _a.endDate;
    return loanTerm === "0" && !interestRate && !startDate && !endDate;
};
export default getSetpayLoanProcessingStatus;
//# sourceMappingURL=getSetpayLoanProcessingStatus.js.map